var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { MessageModifiers } from "../../data";
import { InstantCollapsible, Dropdown } from "sb-resp-ui";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
import { BetPlacementStatus } from "./data";
import * as SCMP from "../../components";
import * as CMP from "./components";
var PulseBetMarkets = /** @class */ (function (_super) {
    __extends(PulseBetMarkets, _super);
    function PulseBetMarkets(props) {
        var _this = _super.call(this, props) || this;
        // setup dictionary
        _this.dict = _this.props.dict;
        _this.countDownValues = ["3", "2", "1", _this.dict.GoLabel];
        // setup data provider
        _this.state = {
            dataProvider: _this.props.dataProvider
        };
        return _this;
    }
    // A check needed to show which component should be rendered
    PulseBetMarkets.prototype.renderPulseBetContainer = function (pulseBetMarket) {
        var _this = this;
        return (React.createElement("div", { className: "rj-pulse-bet-market__collapsible-wrap", key: "" + pulseBetMarket.pulseBetMetadata.name },
            React.createElement(InstantCollapsible, { trigger: React.createElement(SCMP.Heading, { label: pulseBetMarket.pulseBetMetadata.name, isDesktop: this.state.dataProvider.deviceDetect.isDesktop, tooltipMessage: this.dict["Branch" + pulseBetMarket.pulseBetMetadata.branchID + "_" + pulseBetMarket.pulseBetMetadata.typeId + "_"] }), content: React.createElement("div", { className: "rj-pulse-bet-market-main-container" }, this.state.dataProvider.eventsBetPlacementResult.map(function (data) {
                    return pulseBetMarket.pulseBetMetadata.marketId === data.eventId &&
                        _this.renderMarket(data, pulseBetMarket);
                })), initiallyExpanded: true })));
    };
    PulseBetMarkets.prototype.renderPulseContent = function (pulseBetMarket, betPlacementData) {
        var _this = this;
        var isDisabled = this.state.dataProvider.isDanger || pulseBetMarket.pulseBetMetadata.isDanger;
        return (React.createElement("div", { className: "rj-pulse-bet-markets", "data-suspended": isDisabled },
            React.createElement(SCMP.Winnings, { inputData: pulseBetMarket.winings, onStakeChangeFading: pulseBetMarket.onStakeChangeFading }),
            React.createElement(CMP.TimePeriod, { periodFrames: pulseBetMarket.periodFrames.map(function (period) { return period + " " + _this.state.dataProvider.addSuffix(pulseBetMarket.pulseBetMetadata.marketId); }) }),
            React.createElement("div", { className: "rj-pulse-bet-markets__pre-bet" },
                React.createElement(SCMP.SlimProgressbar, { eventID: pulseBetMarket.pulseBetMetadata.marketId })),
            React.createElement("div", { className: "rj-pulse-bet-markets__btns-holder" },
                React.createElement("div", { className: "rj-my-pulse-bets__btn-outer", hidden: !pulseBetMarket.freeBetsEnabled },
                    React.createElement(Dropdown, { data: pulseBetMarket.freeBetOptions, selectItem: pulseBetMarket.onFreePulseBetSelect, blockName: "pulse-bet", defaultText: this.dict.SelectFreeBet })),
                React.createElement("div", { className: "rj-my-pulse-bets__btn-outer", hidden: pulseBetMarket.freeBetsEnabled },
                    React.createElement(CMP.StakeHolder, { data: this.state.dataProvider.stakeInputDataView(pulseBetMarket.pulseBetMetadata.marketId) })),
                React.createElement("div", { className: "rj-my-pulse-bets__pulse-btn-outer" }, this.renderPulseBetButton(pulseBetMarket, isDisabled))),
            React.createElement(CMP.FreeBet, { isActive: pulseBetMarket.hasFreeBetOptions, text: this.state.dataProvider.stakeTypeText(pulseBetMarket.pulseBetMetadata.typeId), toggleStakeType: pulseBetMarket.toggleStakeType }),
            React.createElement("div", { className: "rj-pulse-bet-markets__messages" },
                betPlacementData.status === BetPlacementStatus.Error && React.createElement(CMP.ErrorMessage, { error: betPlacementData.error }),
                this.state.dataProvider.isUserLogged &&
                    this.state.dataProvider.userInfo.TaxProvider && !!this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax &&
                    React.createElement(CMP.GeneralMessage, { text: this.dict.GermanTaxesMessage.format(this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax), modifier: MessageModifiers.Tax }))));
    };
    PulseBetMarkets.prototype.renderPulseBetButton = function (pulseBetMarket, isDisabled) {
        return (React.createElement(SCMP.PulseBetButton, { handler: pulseBetMarket.externalPlaceBetHandler, isDisabled: isDisabled || !this.state.dataProvider.isUserGeolocated || this.state.dataProvider.isPlacingBetsDisabled || (this.state.dataProvider.IsSeamlessOrWallet() && !this.state.dataProvider.isUserLogged) }, this.state.dataProvider.placeButtonText(pulseBetMarket.pulseBetMetadata.typeId)));
    };
    PulseBetMarkets.prototype.getInfoMessages = function () {
        return this.state.dataProvider.store.infoMessages.map(function (x) { return React.createElement(CMP.GeneralMessage, { text: x }); });
    };
    PulseBetMarkets.prototype.renderAcceptedBetMessage = function (betPlacementData) {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__success" },
            React.createElement(CMP.AcceptedBet, { data: betPlacementData.success }),
            this.getInfoMessages()));
    };
    PulseBetMarkets.prototype.renderProcessBetMessage = function () {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__in-process" },
            React.createElement(CMP.PulseLoading, null),
            this.getInfoMessages()));
    };
    PulseBetMarkets.prototype.renderMarket = function (betPlacementData, pulseBetMarket) {
        return (React.createElement(React.Fragment, { key: "" + pulseBetMarket.pulseBetMetadata.marketId }, this.renderPulseBetMarketView(pulseBetMarket, betPlacementData)));
    };
    PulseBetMarkets.prototype.renderPulseBetMarketView = function (pulseBetMarket, betPlacementData) {
        switch (betPlacementData.status) {
            case BetPlacementStatus.InProcess:
                return this.renderProcessBetMessage();
            case BetPlacementStatus.Success:
                return this.renderAcceptedBetMessage(betPlacementData);
            case BetPlacementStatus.Error:
            case BetPlacementStatus.NotStarted:
            default:
                return this.renderPulseContent(pulseBetMarket, betPlacementData);
        }
    };
    PulseBetMarkets.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.state.dataProvider.store.pulsebetsDataForComponents.map(function (data) { return _this.renderPulseBetContainer(data); })));
    };
    PulseBetMarkets = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], PulseBetMarkets);
    return PulseBetMarkets;
}(React.Component));
export { PulseBetMarkets };
//# sourceMappingURL=PulseBetMarkets.js.map